import { render, staticRenderFns } from "./foot1.vue?vue&type=template&id=36672ab0&scoped=true&"
import script from "./foot1.vue?vue&type=script&lang=js&"
export * from "./foot1.vue?vue&type=script&lang=js&"
import style0 from "./foot1.vue?vue&type=style&index=0&id=36672ab0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36672ab0",
  null
  
)

export default component.exports